import { Theme } from '@mui/material'

export enum FontWeight {
  Regular = 400,
  Medium = 500,
  Bold = 600,
}

// Update the Typography's color options to include an ochre option
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    infographic: true
  }
}

export const createResponsiveTypography = (theme: Theme): Partial<Theme['typography']> => ({
  fontFamily: ['Stolzl', 'GtAmericaLcg', 'Arial'].join(','),
  infographic: {
    fontFamily: 'Stolzl',
    fontWeight: FontWeight.Bold,
    [theme.breakpoints.up('xs')]: {
      fontSize: '8rem',
      lineHeight: 1,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '10rem',
      lineHeight: 1,
    },
  },
  // header xxl
  h1: {
    fontFamily: 'Stolzl',
    fontWeight: FontWeight.Bold,
    [theme.breakpoints.up('xs')]: {
      fontSize: 32,
      lineHeight: '36px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 40,
      lineHeight: '49px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 56,
      lineHeight: '60px',
    },
  },
  // header xl
  h2: {
    fontFamily: 'Stolzl',
    fontWeight: FontWeight.Bold,
    [theme.breakpoints.up('xs')]: {
      fontSize: 22,
      lineHeight: '26px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 28,
      lineHeight: '32px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 40,
      lineHeight: '48px',
    },
  },
  // header X
  h3: {
    fontFamily: 'Stolzl',
    fontWeight: FontWeight.Bold,
    [theme.breakpoints.up('xs')]: {
      fontSize: 28,
      lineHeight: '32px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 32,
      lineHeight: '36px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 36,
      lineHeight: '40px',
    },
  },
  // header L
  h4: {
    fontFamily: 'Stolzl',
    fontWeight: FontWeight.Bold,
    [theme.breakpoints.up('xs')]: {
      fontSize: 18,
      lineHeight: '24px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 22,
      lineHeight: '28px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 24,
      lineHeight: '28px',
    },
  },
  // header M
  h5: {
    fontFamily: 'Stolzl',
    fontWeight: FontWeight.Bold,
    [theme.breakpoints.up('xs')]: {
      fontSize: 16,
      lineHeight: '20px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 18,
      lineHeight: '24px',
    },
  },
  // header S
  h6: {
    fontFamily: 'Stolzl',
    fontWeight: FontWeight.Bold,
    [theme.breakpoints.up('xs')]: {
      fontSize: 12,
      lineHeight: '16px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
      lineHeight: '16px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 16,
      lineHeight: '20px',
    },
  },
  // text L
  body1: {
    fontFamily: 'GtAmericaLcg',
    fontWeight: FontWeight.Regular,
    [theme.breakpoints.up('xs')]: {
      fontSize: 16,
      lineHeight: '20px',
    },
    // [theme.breakpoints.up('lg')]: {
    //   fontSize: 18,
    //   lineHeight: '24px',
    // },
  },
  // text M
  body2: {
    fontFamily: 'GtAmericaLcg',
    fontWeight: FontWeight.Regular,
    [theme.breakpoints.up('xs')]: {
      fontSize: 14,
      lineHeight: '16px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 16,
      lineHeight: '20px',
    },
  },
  // text S
  caption: {
    fontFamily: 'GtAmericaLcg',
    fontWeight: FontWeight.Regular,
    [theme.breakpoints.up('xs')]: {
      fontSize: 12,
      lineHeight: '16px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 14,
      lineHeight: '16px',
    },
  },
  subtitle2: {
    fontFamily: 'GtAmericaLcg',
    fontWeight: FontWeight.Regular,
    [theme.breakpoints.up('xs')]: {
      fontSize: 14,
      lineHeight: '16px',
    },
  },
  subtitle1: {
    fontFamily: 'GtAmericaLcg',
    fontWeight: FontWeight.Bold,
    textTransform: 'uppercase',
    [theme.breakpoints.up('xs')]: {
      fontSize: 12,
      lineHeight: '16px',
    },
  },
})
